'use strict';

var NewCalendarDirective = function NewCalendarDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-calendar.html'),
    controller: 'NewCalendarController',
    scope: {
      calendar: '=',
      marketList: '=',
      calendarMode: '=',
      submitCallback: '='
    },
    link: function link($scope, element) {
      element.on('hidden.bs.modal', function () {
        if ($scope.submitted) {
          $timeout(function () {
            $scope.submitCallback();
            $scope.submitted = false;
          }, 0);
        }
      });
      $scope.openSubmitModal = function () {
        element.find('#submit-for-analysis-modal').modal('show');
      };
      $scope.closeSubmitModal = function () {
        element.find('#submit-for-analysis-modal').modal('hide');
      };
      $scope.setValidationFlag();
      $scope.initMarketsForSpecialEvents();
    }
  };
};
NewCalendarDirective.$inject = ['$timeout'];
module.exports = NewCalendarDirective;